let Players = {
    GET_PLAYERS_SUCCESS: 'GET_PLAYERS_SUCCESS',
    SET_IS_PLAYERS_GROUP_READY: 'SET_IS_PLAYERS_GROUP_READY',
    GET_PLAYERS_REGULAR_SUCCESS: 'GET_PLAYERS_REGULAR_SUCCESS',
    UNSET_PLAYERS: 'UNSET_PLAYERS',
    EXCLUDE_PLAYERS: 'EXCLUDE_PLAYERS',
    EXCLUDE_PLAYERS_NOT_IN_SALARY_RANGE: 'EXCLUDE_PLAYERS_NOT_IN_SALARY_RANGE',
    EXCLUDE_CAPTAINS_NOT_IN_SALARY_RANGE: 'EXCLUDE_CAPTAINS_NOT_IN_SALARY_RANGE',
    EXCLUDE_PLAYERS_NOT_IN_POINTS_RANGE: 'EXCLUDE_PLAYERS_NOT_IN_POINTS_RANGE',
    EXCLUDE_CAPTAINS_NOT_IN_POINTS_RANGE: 'EXCLUDE_CAPTAINS_NOT_IN_POINTS_RANGE',
    EXCLUDE_STARS_NOT_IN_POINTS_RANGE: 'EXCLUDE_STARS_NOT_IN_POINTS_RANGE',
    EXCLUDE_PRO_NOT_IN_POINTS_RANGE: 'EXCLUDE_PRO_NOT_IN_POINTS_RANGE',
    RESET_EXCLUDE_PLAYERS_BY_RANGE: 'RESET_EXCLUDE_PLAYERS_BY_RANGE',
    SET_PLAYERS_COUNTERS: 'SET_PLAYERS_COUNTERS',
    DELETE_PLAYERS_BY_IDS: 'DELETE_PLAYERS_BY_IDS',
    CHANGE_PLAYERS_POSITION: 'CHANGE_PLAYERS_POSITION',

    PLAYERS_MODIFICATION_TYPE_SET: 'SET',
    PLAYERS_MODIFICATION_TYPE_MERGE: 'MERGE',

    GET_GAMES_SUCCESS: 'GET_GAMES_SUCCESS',

    SET_TEAM_DETAILS: 'SET_TEAM_DETAILS',
    UNSET_TEAM_DETAILS: 'UNSET_TEAM_DETAILS',
    SET_TEAMS: 'SET_TEAMS',

    GET_SLATES_REQUEST: 'GET_SLATES_REQUEST',
    GET_SLATES_SUCCESS: 'GET_SLATES_SUCCESS',
    GET_SLATES_FAILURE: 'GET_SLATES_FAILURE',
    UNSET_SLATES: 'UNSET_SLATES',
    UPDATE_SLATE: 'UPDATE_SLATE',

    GET_SLATE_REQUEST: 'GET_SLATE_REQUEST',
    GET_SLATE_SUCCESS: 'GET_SLATE_SUCCESS',
    GET_SLATE_FAILURE: 'GET_SLATE_FAILURE',

    SET_GAMES_FILTER: 'SET_GAMES_FILTER',
    SET_PLAYER_POSITIONS_FILTER: 'SET_PLAYER_POSITIONS_FILTER',
    SET_PLAYER_CONFIRMED_FILTER: 'SET_PLAYER_CONFIRMED_FILTER',
    SET_PLAYER_SALARY_RANGE: 'SET_PLAYER_SALARY_RANGE',
    SET_CAPTAIN_SALARY_RANGE: 'SET_CAPTAIN_SALARY_RANGE',
    SET_USER_POINTS_RANGE: 'SET_USER_POINTS_RANGE',
    SET_POINTS_RANGE: 'SET_POINTS_RANGE',
    SET_CAPTAINS_USER_POINTS_RANGE: 'SET_CAPTAINS_USER_POINTS_RANGE',
    SET_PLAYERS_USER_POINTS: 'SET_PLAYERS_USER_POINTS',
    SET_PLAYERS_SCORE: 'SET_PLAYERS_SCORE',
    SET_CAPTAINS_USER_POINTS: 'SET_CAPTAINS_USER_POINTS',
    SET_CAPTAINS_SCORE: 'SET_CAPTAINS_SCORE',
    SET_STARS_USER_POINTS: 'SET_STARS_USER_POINTS',
    SET_STARS_SCORE: 'SET_STARS_SCORE',
    SET_PRO_USER_POINTS: 'SET_PRO_USER_POINTS',
    SET_PRO_SCORE: 'SET_PRO_SCORE',
    SET_PLAYERS_EXPOSURE: 'SET_PLAYERS_EXPOSURE',
    SET_USER_POINTS_BY: 'SET_USER_POINTS_BY',
    SET_PLAYERS_SORT_BY: 'SET_PLAYERS_SORT_BY',

    SET_PLAYERS_POINTS: 'SET_PLAYERS_POINTS',
    SET_PLAYERS_SCORES: 'SET_PLAYERS_SCORES',
    SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_CSV: 'SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_CSV',
    SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_STORAGE: 'SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_STORAGE',

    SET_PREPARED_PLAYERS_LIST: 'SET_PREPARED_PLAYERS_LIST',
    SET_PLAYERS_LINE_GROUP: 'SET_PLAYERS_LINE_GROUP',
    SET_PLAYERS_PP_LINE: 'SET_PLAYERS_PP_LINE',

    SET_GROUPS_OF_STACKS: 'SET_GROUPS_OF_STACKS',
    SET_TEAM_NAME_STACKING_GROUPS: 'SET_TEAM_NAME_STACKING_GROUPS',
    RESET_GROUPS_OF_STACKS: 'RESET_GROUPS_OF_STACKS',

    FILTER_BY_PLAYERS_TYPE: 'FILTER_BY_PLAYERS_TYPE',
    FILTER_BY_PLAYER_NAME: 'FILTER_BY_PLAYER_NAME',
    FILTER_BY_TEAM: 'FILTER_BY_TEAM',
    FILTER_BY_PLAYER_SALARY_FILTER: 'FILTER_BY_PLAYER_SALARY_FILTER',
    FILTER_BY_CAPTION_SALARY_FILTER: 'FILTER_BY_CAPTION_SALARY_FILTER',
    FILTER_BY_USER_POINTS_FILTER: 'FILTER_BY_USER_POINTS_FILTER',
    FILTER_BY_CAPTION_USER_POINTS_FILTER: 'FILTER_BY_CAPTION_USER_POINTS_FILTER',
    FILTER_BY_STAR_USER_POINTS_FILTER: 'FILTER_BY_STAR_USER_POINTS_FILTER',
    FILTER_BY_PRO_USER_POINTS_FILTER: 'FILTER_BY_PRO_USER_POINTS_FILTER',

    PLAYERS_TIERS_FILTER_ALL: '*',
    PLAYERS_SHOWDOWN_FILTER_ALL: '*',
    PLAYERS_SINGLEGAME_FILTER_ALL: '*',
    PLAYERS_SINGLEGAME_FILTER_GUARD: 'G',
    PLAYERS_SINGLEGAME_FILTER_NOT_GUARD: 'F/C',
    PLAYERS_CONFIRMED_FILTER_ALL: '*',
    PLAYERS_TEAM_FILTER_ALL: '*',

    LP_ITEM_DELIMITER: '_',
    LP_UNIT_PREFIX: 'x',
    LP_DUPLICATE_UNIT_PREFIX: 'd',
    LP_KEY_UNIT_PREFIX: 'k',
    LP_TEAM_GROUP_PREFIX: 't',
    LP_SUBGROUP_PREFIX: 's',
    LP_CS_PRIMARY_STACK_GROUP_PREFIX: 's',
    LP_CS_COMBINATION_PREFIX: 'c',
    LP_CS_GAME_COMBINATION_PREFIX: 'g',
    LP_CS_UNIVERSAL_STACK_GROUP_PREFIX: 'u',
    LP_NON_CONTROLLED_HITTER_STACK_SUFFIX: 'NCHS',
    LP_NHL_TEAM_STACKING_SUFFIX: 'NHLTS',
    LP_NHL_LEGACY_TEAM_STACKING_SUFFIX: 'NHLLTS',
    LP_RANDOM_TEAMS_STACK_SUFFIX: 'RTS',
    LP_COMPETITION_STACK_SUFFIX: 'FS', //todo ujin dont forget to change value after first iteration of testing
    LP_KEY_PLAYER_STACK_SUFFIX: 'KPS',
    LP_PLAYER_COMBINATION_STACK_SUFFIX: 'PCS',
    LP_SINGLEGAME_FORCED_STACK_SUFFIX: 'FGFS',
    LP_CAPTAIN_PLAYER_POSITION: 1,
    LP_COMMON_PLAYER_POSITION: 2,
    LP_STAR_PLAYER_POSITION: 3,
    LP_PRO_PLAYER_POSITION: 4,

    EXCLUDED_BY_USER: 'excludedByUser',
    EXCLUDED_BY_SALARY_RANGE: 'excludedBySalaryRange',
    EXCLUDED_BY_CAPTAIN_SALARY_RANGE: 'excludedByCaptainSalaryRange',
    EXCLUDED_BY_POINTS_RANGE: 'excludedByPointsRange',
    EXCLUDED_BY_CAPTAIN_POINTS_RANGE: 'excludedByCaptainPointsRange',
    EXCLUDED_BY_STAR_POINTS_RANGE: 'excludedByStarPointsRange',
    EXCLUDED_BY_PRO_POINTS_RANGE: 'excludedByProPointsRange',
    EXCLUDED_BY_ORDER_RANGE: 'excludedByOrderRange',
    EXCLUDED_BY_CONFIRMED_RANGE: 'excludedByConfirmedRange',
    EXCLUDED_BY_LINE_GROUPS_RANGE: 'excludedByLineGroupsRange',

    DEFAULT_MIN_UNIQUE_PLAYERS_IN_LINEUP: 1,
    DEFAULT_MAX_UNIQUE_PLAYERS_IN_LINEUP: 6,

    /**
     * Actual only for MLB
     */
    EXCLUDE_PLAYERS_NOT_IN_ORDER_RANGE: 'EXCLUDE_PLAYERS_NOT_IN_ORDER_RANGE',
    EXCLUDE_PLAYERS_NOT_IN_CONFIRMED_RANGE: 'EXCLUDE_PLAYERS_NOT_IN_CONFIRMED_RANGE',

    MLB_PLAYER_CONFIRMED: 1,

    NHL_LINE_GROUP_MIN: 0,
    NHL_LINE_GROUP_MAX: 4,

    NHL_PP_LINE_MIN: 0,
    NHL_PP_LINE_MAX: 2,
    /**
     * Actual only for NHL
     */
    EXCLUDE_PLAYERS_NOT_IN_LINE_GROUPS: 'EXCLUDE_PLAYERS_NOT_IN_LINE_GROUPS',

    UPDATE_PLAYER_PARAMS: 'UPDATE_PLAYER_PARAMS',
    SET_SYMPATHY: 'SET_SYMPATHY',
    RESET_SYMPATHY: 'RESET_SYMPATHY',
    RESET_PP_LINE: 'RESET_PP_LINE',
    RESET_PLAYERS_LINE_GROUPS: 'RESET_PLAYERS_LINE_GROUPS',
    SET_DOMINATOR: 'SET_DOMINATOR',
    SYMPATHY_DEFAULT: 'none',
    SYMPATHIES_LIST: {
        adore: 15,
        love: 10,
        like: 5,
        none: 0,
        dislike: -5,
        hate: -10,
        enrage: -15,
    },

    CFB_DK_CAPTAIN_SALARY_COEFFICIENT: 1.5,

    RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE: 0,
    RANGES_OF_OUTCOMES_DEFAULT_VALUES: {
        nba: 0,
    },
    RANGES_OF_OUTCOMES: {
        golf: 50,
        nascar: 50,
        mma: 50,
        mlb: 50,
        nba: 50,
        nfl: 50,
        nhl: 50,
        cfb: 50,
        lol: 50,
        tennis: 50,
        f1: 50,
    },

    PLAYERS_SORT_COLS_LIST: {
        golf: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                userScore: 'Fpts/$',
                points: 'Odds',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
                projected_ownership: 'pOwn%',
                grades: 'Rating',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                userScore: 'Fpts/$',
                points: 'Odds',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
                projected_ownership: 'pOwn%',
                grades: 'Rating',
            },
            tiers: {
                name: 'Name',
                rosterPosition: 'Tier',
                points: 'Odds',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
                projected_ownership: 'pOwn%',
                grades: 'Rating',
            },
        },
        mlb: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                hand: 'Hand',
                order: 'Order',
                moneyLine: 'Money Line',
                grades: 'Rating',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            tiers: {
                rosterPosition: 'Tier',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                hand: 'Hand',
                order: 'Order',
                moneyLine: 'Money Line',
                grades: 'Rating',
                userPoints: 'FPts',
                adminPoints: 'Proj',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                hand: 'Hand',
                order: 'Order',
                moneyLine: 'Money Line',
                grades: 'Rating',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            'single-game': {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                hand: 'Hand',
                order: 'Order',
                moneyLine: 'Money Line',
                grades: 'Rating',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        mma: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                opponent: 'Opponent',
                gameInfo: 'Fight',
                userScore: 'Fpts/$',
                points: 'Odds',
                fptsWin: 'Fpts/Win',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                opponent: 'Opponent',
                gameInfo: 'Fight',
                userScore: 'Fpts/$',
                points: 'Odds',
                fptsWin: 'Fpts/Win',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        nascar: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                starting: 'Starting',
                dominator: 'Dominator',
                manufacturer: 'Manufacturer',
                p1: 'P1',
                longRun: 'Long Run',
                userScore: 'Fpts/$',
                points: 'Odds',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
                projected_ownership: 'pOwn%',
            },
        },
        nba: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                projected_ownership: 'Proj Own',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                ceilingPoints: 'Ceiling Proj',
                pra: 'PRA',
                grades: 'Rating',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            tiers: {
                name: 'Name',
                position: 'Position',
                rosterPosition: 'Tier',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userPoints: 'FPts',
                adminPoints: 'Proj',
                ceilingPoints: 'Ceiling Proj',
                pra: 'PRA',
                grades: 'Rating',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                ceilingPoints: 'Ceiling Proj',
                pra: 'PRA',
                grades: 'Rating',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            'single-game': {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                ceilingPoints: 'Ceiling Proj',
                pra: 'PRA',
                grades: 'Rating',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        nfl: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                sharpPoints: 'Props Proj',
                ceilingPoints: 'Ceiling Proj',
                grades: 'Rating',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            tiers: {
                name: 'Name',
                position: 'Position',
                rosterPosition: 'Tier',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userPoints: 'FPts',
                adminPoints: 'Proj',
                sharpPoints: 'Props Proj',
                ceilingPoints: 'Ceiling Proj',
                grades: 'Rating',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            'single-game': {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                sharpPoints: 'Props Proj',
                ceilingPoints: 'Ceiling Proj',
                grades: 'Rating',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                dvp: 'DvP',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                sharpPoints: 'Props Proj',
                ceilingPoints: 'Ceiling Proj',
                grades: 'Rating',
                userPoints: 'FPts',
                projected_ownership: 'pOwn%',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        cfb: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                userScore: 'Fpts/$',
                projected_ownership: 'pOwn%',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            'single-game': {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        nhl: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                projected_ownership: 'Proj Own',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            showdown: {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            'single-game': {
                salary: 'Salary',
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
            tiers: {
                name: 'Name',
                position: 'Position',
                rosterPosition: 'Tier',
                team: 'Team',
                opponent: 'Opponent',
                userPoints: 'FPts',
                adminPoints: 'Proj',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        lol: {
            classic: {
                name: 'Name',
                position: 'Position',
                team: 'Team',
                opponent: 'Opponent',
                moneyLine: 'Money Line',
                impliedWinProbability: 'Win%',
                salary: 'Salary',
                userScore: 'Fpts/$',
                points: 'Fpts/Win',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        tennis: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                opponent: 'Opponent',
                gameInfo: 'Match',
                userScore: 'Fpts/$',
                points: 'Odds',
                fptsWin: 'Fpts/Win',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
        f1: {
            classic: {
                salary: 'Salary',
                name: 'Name',
                starting: 'Starting',
                winOdds: 'Win Odds',
                t6Odds: 'T6 Odds',
                t10Odds: 'T10 Odds',
                userScore: 'Fpts/$',
                adminPoints: 'Proj',
                userPoints: 'FPts',
                exposureMin: 'Exp. Min',
                exposureMax: 'Exp. Max',
            },
        },
    },

    MOBILE_SORT_DEFAULT: {
        col: 'salary',
        direction: 'desc',
    },

    MOBILE_SORT: {
        golf: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
            tiers: {
                col: 'rosterPosition',
                direction: 'asc',
            },
        },
        mlb: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            tiers: {
                col: 'rosterPosition',
                direction: 'asc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
            'single-game': {
                col: 'salary',
                direction: 'desc',
            },
        },
        mma: {
            classic: {
                col: 'gameInfo',
                direction: 'desc',
            },
            showdown: {
                col: 'gameInfo',
                direction: 'desc',
            },
        },
        nascar: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
        },
        nba: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            tiers: {
                col: 'rosterPosition',
                direction: 'asc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
            'single-game': {
                col: 'salary',
                direction: 'desc',
            },
        },
        nfl: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            tiers: {
                col: 'rosterPosition',
                direction: 'asc',
            },
            'single-game': {
                col: 'salary',
                direction: 'desc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
        },
        cfb: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            'single-game': {
                col: 'salary',
                direction: 'desc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
        },
        nhl: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
            showdown: {
                col: 'salary',
                direction: 'desc',
            },
            'single-game': {
                col: 'salary',
                direction: 'desc',
            },
            tiers: {
                col: 'rosterPosition',
                direction: 'asc',
            },
        },
        lol: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
        },
        tennis: {
            classic: {
                col: 'gameInfo',
                direction: 'desc',
            },
        },
        f1: {
            classic: {
                col: 'salary',
                direction: 'desc',
            },
        },
    },

    MLB_POSITIONS_MAP: {
        hitter: ['C', '1B', '2B', '3B', 'SS', 'OF'],
        pitcher: ['P', 'RP', 'SP'],
    },

    DRAFTKINGS_FORCED_RANGE_OF_OUTCOMES_PTC: 1,
    LINEUPS_QUANTITY_FOR_USING_FORCED_RANGE_OF_OUTCOMES_PTC: 150,
};

export default Players;
